/**
 * Humanize a snake_case credit role key into a readable Title Case string.
 * Used as fallback when no i18n translation exists for the role.
 *
 * Example: "sleeve_notes_from_the_london_observer" → "Sleeve Notes From The London Observer"
 */
export function formatCreditRole(role: string): string {
  return role.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
